var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadioButtonUnchecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10727_54636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 2.50195C5.40008 2.50195 1.66675 6.23529 1.66675 10.8353C1.66675 15.4353 5.40008 19.1686 10.0001 19.1686C14.6001 19.1686 18.3334 15.4353 18.3334 10.8353C18.3334 6.23529 14.6001 2.50195 10.0001 2.50195ZM10.0001 17.502C6.31675 17.502 3.33341 14.5186 3.33341 10.8353C3.33341 7.15195 6.31675 4.16862 10.0001 4.16862C13.6834 4.16862 16.6667 7.15195 16.6667 10.8353C16.6667 14.5186 13.6834 17.502 10.0001 17.502Z",
    fill: "#97A3B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10727_54636"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.835938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioButtonUnchecked);
export default __webpack_public_path__ + "static/media/RadioButtonUnchecked.fa9744a56e883c16a05ecc21571a3832.svg";
export { ForwardRef as ReactComponent };